module.exports = __webpack_public_path__ + "media/images/dummy-0c3fec96c2afb63cf85250229832fa7a.png";